import gsap , {Power1 }from "gsap";

export default function ComponentKeywords() {
    const keywords = document.querySelectorAll('.a-word[data-keyword]');

    if (keywords.length > 0) {
        keywords.forEach((el) => new Keyword(el))
    }
}


export class Keyword {
    constructor(dom) {
        this.DOM = dom
        this.words = []
        this.words = dom.dataset.keyword.split(',')
        this.words = this.words.filter( word => word.length > 0)

        this.numberOfWordToDisplay = 1
        this.duration = 2000
        // 

        let span = document.createElement("span")
        this.DOM.innerHTML = '';
        this.DOM = this.DOM.appendChild(span)
        this.init()
    }

    init() {
        this.DOM.innerHTML = this.words[0];
        this.animate()
    }

    animate() {
        var tl = gsap.timeline({repeat:-1})
        tl.set(this.DOM, {display:'block'})
        tl.to(this.DOM, { opacity: 0, x: 10, duration: .5, onComplete: ()=> {this.changeWord()}}, "+=2")
        tl.to(this.DOM, { opacity: 1, x: 0, duration: .5, ease : Power1.easeOut })
    }

    changeWord() {
        this.DOM.innerHTML = this.words[this.numberOfWordToDisplay]
        this.incrementWorddisplay()
    }

    incrementWorddisplay() {
        if (this.numberOfWordToDisplay === this.words.length - 1) {
            this.numberOfWordToDisplay = 0
        } else {
            this.numberOfWordToDisplay += 1
        }
    }
}   